import { Record } from 'src/app/Layouts/admin-dashboard/food-safety-system/documents/document-details/models/records.model';

export interface GetDocumentByIdRequestPayload {
  id: number;
}

export interface GetDocumentContentByIdRequestPayload {
  documentId: number;
}

export interface DocumentDetails {
  title: string;
  doc_type_id: string;
  leadIds: number[];
  authorized_by_id: string;
  section: string;
  backupIds: number[];
  id: string;
  createdAt: string;
  subsection: string;
  readAccessIds: number[];
  updatedAt: string;
  reasonForChange: string;
  version: number;
  documents: string[];
  record_id: number[];
  editorContent: string;
}

export interface DocumentContentDetails {
  id: string;
  editorContent: string;
}

export interface DocumentsState {
  getAllDocumentsSuccess: any;
  getAllDocumentsError: any;
  getAddDocumentsSuccess: any;
  getAddDocumentsError: any;
  getEditDocumentsSuccess: any;
  getEditDocumentsError: any;
  getDocumentsTypeSuccess: any;
  getDocumentsTypeError: any;
  addDocumentsTypeSuccess: any;
  addDocumentsTypeError: any;
  getTypeRecordSuccess: any;
  getTypeRecordError: any;
  getDocumentsByIdSuccess: DocumentDetails[];
  getDocumentsByIdError: any;
  getDocumentContentByIdSuccess: DocumentContentDetails[];
  getDocumentContentByIdError: any;
  getDocumentCountSuccess: any;
  getDocumentCountError: any;
  getDocumentSearchSuccess: any;
  getDocumentsSearchError: any;
  downloadDocumentFileSuccess: any;
  downloadDocumentFileError: any;
  getDocumentsNameSuccess: any;
  getDocumentsNameError: any;
  addDocumentsNameSuccess: any;
  addDocumentsNameError: any;
  getDocumentImportSuccess: any;
  getDocumentImportError: any;
  uploadDocumentsSuccess: any;
  uploadDocumentsError: any;
  removeDocumentSuccess: any;
  removeDocumentError: any;
  documentsDetails: DocumentDetails;
  documentDetailsError: any;
  allRecords: Record[];
  allRecordsError: any;
  addDocumentInProgress: boolean;
  allRecordsInProgress: boolean;
  getDocumentTypeInProgress: boolean;
  getDocumentsIdInProgress: boolean;
  getDocumentContentByIdInProgress: boolean;
  editDocumentsInProgress: boolean;
  acknowledgeDocument: boolean
}

export const InitialDocumentState: DocumentsState = {
  getAllDocumentsSuccess: null,
  getAllDocumentsError: null,
  getAddDocumentsSuccess: null,
  getAddDocumentsError: null,
  getEditDocumentsSuccess: null,
  getEditDocumentsError: null,
  getDocumentsTypeSuccess: null,
  getDocumentsTypeError: null,
  addDocumentsTypeSuccess: null,
  addDocumentsTypeError: null,
  getTypeRecordSuccess: null,
  getTypeRecordError: null,
  getDocumentsByIdSuccess: null,
  getDocumentsByIdError: null,
  getDocumentContentByIdSuccess: null,
  getDocumentContentByIdError: null,
  getDocumentCountSuccess: null,
  getDocumentCountError: null,
  getDocumentSearchSuccess: null,
  getDocumentsSearchError: null,
  downloadDocumentFileSuccess: null,
  downloadDocumentFileError: null,
  getDocumentsNameSuccess: null,
  getDocumentsNameError: null,
  addDocumentsNameSuccess: null,
  addDocumentsNameError: null,
  getDocumentImportSuccess: null,
  getDocumentImportError: null,
  uploadDocumentsSuccess: null,
  uploadDocumentsError: null,
  removeDocumentSuccess: null,
  removeDocumentError: null,
  documentDetailsError: null,
  allRecordsError: null,
  addDocumentInProgress: false,
  documentsDetails: {
    title: '',
    doc_type_id: '',
    leadIds: [],
    createdAt: '',
    section: '',
    backupIds: [],
    subsection: '',
    readAccessIds: [],
    record_id: [],
    id: '',
    updatedAt: '',
    reasonForChange: '',
    version: 0,
    authorized_by_id: '',
    documents: [],
    editorContent: '',
  },
  allRecords: [],
  allRecordsInProgress: false,
  getDocumentTypeInProgress: false,
  getDocumentsIdInProgress: false,
  getDocumentContentByIdInProgress: false,
  editDocumentsInProgress: false,
  acknowledgeDocument: false,
};
